import React, { Component } from 'react'

import * as d3Axis from 'd3-axis'
import { select as d3Select } from 'd3-selection'
import { timeFormat, timeParse } from 'd3'

import './index.scss'

export class Axis extends Component {
  componentDidMount() {
    this.renderAxis()
  }

  componentDidUpdate() {
    this.renderAxis()
  }

  renderAxis() {
    const axisType = `axis${this.props.orient}`;
    let axis = d3Axis[axisType]()
      .scale(this.props.scale)
      .tickSize(-this.props.tickSize)
      .tickPadding([20]);

    if (this.props.orient === 'Bottom') {
      axis = axis.tickFormat(timeFormat("%H:%M"))
    }

    d3Select(this.axisElement).call(axis)
  }

  render() {
    return (
      <g
        className={`Axis Axis-${this.props.orient}`}
        ref={(el) => { this.axisElement = el; }}
        transform={ this.props.translate }
      />
    )
  }
}

export class Points extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {scales, data} = this.props;
    const {xScale, yScale, colorScale} = scales;

    const parseTime = timeParse("%Y-%m-%dT%H:%M:%SZ");

    let i = 0;

    const points = (
      data.map(datum =>
        <circle
          key={i++}
          cx={xScale(parseTime(datum.timeSeen))}
          cy={yScale(datum.zoneId)}
          r="5"
          fill={colorScale(datum.zoneId)}
        />)
    );

    return (
      <g>{points}</g>
    )
  }
}

export default ({ scales, margins, svgDimensions }) => {
  const { height, width } = svgDimensions

  const xProps = {
    orient: 'Bottom',
    scale: scales.xScale,
    translate: `translate(0, ${height - margins.bottom})`,
    tickSize: height - margins.top - margins.bottom,
  };

  const yProps = {
    orient: 'Left',
    scale: scales.yScale,
    translate: `translate(${margins.left}, 0)`,
    tickSize: width - margins.left - margins.right,
  };

  return (
    <g>
      <Axis {...xProps} />
      <Axis {...yProps} />
    </g>
  )
}



// WEBPACK FOOTER //
// ./src/pages/directory/contact-details/components/holder-zone-report/movement-timeline/index.js